module.exports = __webpack_public_path__ + "static/img/index_01_04.8ff3b99.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index_01_04.png
// module id = 6tRH
// module chunks = 1